import {
	CAPABILITY_HEADER_NAME,
	type CapabilityLoadType,
} from '@jira/platform__observability-capabilities/src/constants.tsx';
import { getEnhancedCapabilityHeader } from './index.tsx';

export function getCapabilityMetadataHeaders(
	existingHeaders: unknown,
	capability: string,
	capabilityLoadType?: CapabilityLoadType,
): Record<string, string> | undefined {
	const capabilityHeader = getEnhancedCapabilityHeader(capability, capabilityLoadType);

	if (typeof capabilityHeader !== 'string') {
		return undefined;
	}

	const headers: Record<string, string> = {};
	if (existingHeaders != null && typeof existingHeaders === 'object') {
		for (const [name, value] of Object.entries(existingHeaders)) {
			if (typeof value === 'string') {
				headers[name] = value;
			}
		}
	}

	for (const name of Object.keys(headers)) {
		if (name.toLowerCase() === CAPABILITY_HEADER_NAME.toLowerCase()) {
			delete headers[name];
		}
	}

	headers[CAPABILITY_HEADER_NAME] = capabilityHeader;
	return headers;
}
